// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.


//Production Agro viva 644
export const environment = {
  production: true,
  cloudFirestore: {
    apiKey: 'AIzaSyBxc3MzLaM_gYPhgfVWuN7PLVZ2FjnAnJ4',
    authDomain: 'agro-viva.firebaseapp.com',
    databaseURL: 'https://agro-viva.firebaseio.com',
    projectId: 'agro-viva',
    storageBucket: 'agro-viva.appspot.com',
    messagingSenderId: '109100088712'
  }
};


//Production Sire web UP 312 (ya no esta en uso)
/*
export const environment = {
  production: true,
  cloudFirestore: {
    apiKey: "AIzaSyDP3NRnRLL2fKG7lDC3l7XeZ9h4CMaO8gQ",
    authDomain: "sire-web.firebaseapp.com",
    databaseURL: "https://sire-web.firebaseio.com",
    projectId: "sire-web",
    storageBucket: "sire-web.appspot.com",
    messagingSenderId: "125204772506"
  }
};
*/

//Production Sire Mex UP 158 (SIREIlusa, si esta en uso)
/* 
export const environment = {
  production: true,
  cloudFirestore: {
    apiKey: "AIzaSyBv9hSACuKB5InlMjUwFBQD7Ka5eGNvYzk",
    authDomain: "sireilusa.firebaseapp.com",
    databaseURL: "https://sireilusa.firebaseio.com",
    projectId: "sireilusa",
    storageBucket: "sireilusa.appspot.com",
    messagingSenderId: "675232206735"
  }
}; 
*/

//Production Proy-pruebas NEW STAGING  123
/*
export const environment = {
  production: true,
  cloudFirestore: {
    apiKey: "AIzaSyDUxla1MR8ecO4ydce03kjTZ9DbJicNRj0",
    authDomain: "proy-pruebas.firebaseapp.com",
    databaseURL: "https://proy-pruebas.firebaseio.com",
    projectId: "proy-pruebas",
    storageBucket: "proy-pruebas.appspot.com",
    messagingSenderId: "30392605437"
  }
};
*/
